module.exports = __webpack_public_path__ + "media/flags/er-cee4e6b1.svg";